import { useAppState } from '@/providers/AppStateProvider';
import { Tab } from '@/components/TabsBlock';
import Divider from '@/components/Divider';
import FormsSection from './FormsSection';
import DocumentsSection from './DocumentsSection';
import { classes } from './utils';

export type DocumentsTabProps = {
  isFetchingData: boolean;
  name: string;
  label: string;
};

export default function DocumentsTab({
  isFetchingData,
  name,
  label,
}: DocumentsTabProps) {
  const { activeProjectId } = useAppState();

  if (!activeProjectId) return null;
  return (
    <>
      <Tab className={classes.tab} name={name} label={label}>
        <FormsSection isFetchingData={isFetchingData} />
        <Divider />
        <DocumentsSection isFetchingData={isFetchingData} />
      </Tab>
    </>
  );
}
